import React from "react";
import "./FuturesNews.css";
const FuturesNews = () => {
  return (
    <>
      <div className="container mb-2">
        <div className="row justify-content-around p-2">
          <div className="card my-3 mx-2 p-0">
            <a href="#">
              <img
                className="card-img-top"
                src="https://onlinebuzzmall.com/assets/images/platform-rules/y2FzxJ3oON1732375236.png"
                alt="Card image cap"
              />
              <div className="card-body">
                <h5 className="card-title">Platform profile</h5>
                <p className="card-text">
                  MALL is an intelligent cloud global order matching center
                  with...
                </p>
              </div>
            </a>
          </div>
          <div className="card my-3 mx-2 p-0">
            <a href="#">
              <img
                className="card-img-top"
                src="https://onlinebuzzmall.com/assets/images/platform-rules/M1mZ6pLcqk1732375243.png"
                alt="Card image cap"
              />
              <div className="card-body">
                <h5 className="card-title">Platform rules</h5>
                <p className="card-text">
                  About recharge: The platform will change the recharge method
                  from...
                </p>
              </div>
            </a>
          </div>
          <div className="card my-3 mx-2 p-0">
            <a href="#">
              <img
                className="card-img-top"
                src="https://onlinebuzzmall.com/assets/images/platform-rules/ufwR4xYmzr1737797994.png"
                alt="Card image cap"
              />
              <div className="card-body">
                <h5 className="card-title">Win-win cooperation</h5>
                <p className="card-text">
                  At MALL, we carry out win-win cooperation for all users...
                </p>
              </div>
            </a>
          </div>
          <div className="card my-3 mx-2 p-0">
            <a href="#">
              <img
                className="card-img-top"
                src="https://onlinebuzzmall.com/assets/images/platform-rules/Ich9QfM6rC1737797950.webp"
                alt="Card image cap"
              />
              <div className="card-body">
                <h5 className="card-title">Instructions for use</h5>
                <p className="card-text">
                  Some questions about deposits: 1.Users need to obtain a new...
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default FuturesNews;
